import RevenueCards from '../../components/revenueCard/RevenueCards';

const Reporting = () => {
    const data = {
        totalRevenue: 57320,
        monthRevenue: 22450,
        pendingPayout: 4780,
        totalTrips: 128
    };
    return (
        <div>
            <h2>Organizer Dashboard</h2>
            <RevenueCards data={data} />
        </div>
    );
};

export default Reporting;
